import { makeEntityScaffold } from '@classpass/saga-tools';
import LocationDeriver from 'derivers/Location';
var KEY = 'SAGA.API.GLS';
var DEFAULT_LOCALE_INFO = {
  address_fields: {
    address_line_1: 'REQUIRED',
    address_line_2: 'OPTIONAL',
    city: 'REQUIRED',
    postal_code: 'REQUIRED',
    state_code: 'REQUIRED'
  }
};
export var getAddressRequirements = makeEntityScaffold("".concat(KEY, ".GET_LOCALE_INFO"), function (client, countryShortCode) {
  return client.gls.getLocaleInfo(countryShortCode).then(function (data) {
    return LocationDeriver.addressRequirements(data);
  }).catch(function () {
    return LocationDeriver.addressRequirements(DEFAULT_LOCALE_INFO);
  });
}, {
  defaultKey: [1]
});
export var glsLocation = makeEntityScaffold("".concat(KEY, ".GLS_USER_LOCATION"), function (client, latitude, longitude) {
  return client.gls.getUserLocationV2({
    latitude: latitude,
    longitude: longitude
  });
}, {
  defaultKey: [1, 2]
});